var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28571 1H11.7143C14.0812 1 16 2.88504 16 5.21036V11.5259C16 13.8512 14.0812 15.7363 11.7143 15.7363H5.28571C2.91878 15.7363 1 13.8512 1 11.5259V5.21036C1 2.88504 2.91878 1 5.28571 1ZM5.28856 2.40311H11.7171C13.2951 2.40311 14.5743 3.65981 14.5743 5.21002V11.5256C14.5743 13.0758 13.2951 14.3325 11.7171 14.3325H5.28856C3.7106 14.3325 2.43141 13.0758 2.43141 11.5256V5.21002C2.43141 3.65981 3.7106 2.40311 5.28856 2.40311ZM12.4261 8.36752C12.4261 6.23598 10.6672 4.50802 8.49751 4.50802C6.35914 4.58052 4.64274 6.26674 4.56894 8.36752C4.56894 10.4991 6.32782 12.227 8.49751 12.227C10.6672 12.227 12.4261 10.4991 12.4261 8.36752ZM8.55378 5.91449C9.20192 5.91412 9.82365 6.1668 10.2821 6.61691C10.7405 7.06702 10.9981 7.67766 10.9981 8.31439C10.9588 9.67912 9.84086 10.7758 8.45163 10.8125C7.80356 10.8129 7.18191 10.5602 6.72358 10.1101C6.26525 9.65995 6.00784 9.04931 6.00803 8.41264C6.04768 7.04832 7.16499 5.95191 8.55378 5.91449ZM12.5434 4.22356C12.5434 3.84206 12.2341 3.5328 11.8526 3.5328C11.4712 3.5328 11.1619 3.84206 11.1619 4.22356C11.1619 4.60506 11.4712 4.91432 11.8526 4.91432C12.2341 4.91432 12.5434 4.60506 12.5434 4.22356Z",
    fill: "#274054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.768033c16e8012ceed729888c902fc33.svg";
export { ForwardRef as ReactComponent };